import { useForm } from "react-hook-form";
import { FormControlledSearchInput } from "ui/molecules/form/FormControlledSearchInput";
import { useResidentsFilterContext } from "../context/ResidentsFilterContext";

export function SearchField() {
  const { search, updateSearch } = useResidentsFilterContext();

  const { control } = useForm({
    defaultValues: {
      search: search,
    },
  });

  return (
    <FormControlledSearchInput
      control={control}
      name="search"
      id="search"
      placeholder="Search"
      onDebounce={(value) => {
        updateSearch(value || "");
      }}
    />
  );
}
